import { ListOrdered } from 'lucide-react';
import { cn } from '@/shared/lib/cn';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/ui/select';

export const LEAD_PAGE_SIZE_OPTIONS = [25, 50, 100, 200, 500] as const;

interface PageSizeSelectProps {
  value: number;
  options?: readonly number[];
  onChange: (size: number) => void;
  className?: string;
}

export function PageSizeSelect({
  value,
  options = LEAD_PAGE_SIZE_OPTIONS,
  onChange,
  className,
}: PageSizeSelectProps) {
  return (
    <Select value={String(value)} onValueChange={(v) => onChange(Number(v))}>
      <SelectTrigger className={cn('w-auto gap-1.5 pr-3', className)}>
        <ListOrdered className="size-3.5 shrink-0 text-muted-foreground" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {options.map((n) => (
          <SelectItem key={n} value={String(n)}>
            {n} por página
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
